<section>
    <div class="title mb-4">
        <h2>Manage Survey</h2>
        <p style="font-size: 0.6rem;"><q>For Member Survey ( View / Edit / delete )</q></p>
    </div>

    <ul class="nav nav-tabs">
        <li class="nav-item">
            <a class="nav-link" [ngClass]="{'active':selMenu=='survey'}" (click)="selectMenu('survey')">Survey
                Dashboard</a>
        </li>

        <li class="nav-item">
            <a class="nav-link" [ngClass]="{'active':selMenu=='questions'}"
                (click)="selectMenu('questions')">Questions</a>
        </li>

        <li class="nav-item">
            <a class="nav-link" [ngClass]="{'active':selMenu=='interests'}" (click)="selectMenu('interests')">Tag</a>
        </li>
    </ul>

    <!-- survey -->
    <section [ngStyle]="{'display': selMenu=='survey' ? 'block' :'none' }" class="mt-3">
        <div class="d-flex justify-content-end" (click)="openSurveyAddEdit(AddSurvey)">
            <button class="btn btn-primary">
                <i class="fa-solid fa-plus"></i> Add Survey
            </button>
        </div>
        <div class="row mt-3">
            <ng-container *ngFor="let item of allList">
                <section class="col-4 survey ">

                    <div class=" d-flex justify-content-between">
                        <h3> <i class="fa fa-file-text mr-2" aria-hidden="true"></i>{{item?.title}} Survey</h3>
                        <div>
                            <label class="m-0" (click)="openSurveyAddEdit(item)"><i class="fa fa-pencil"
                                    aria-hidden="true"></i> Edit</label>
                            <label class="ml-3" (click)="openQuestionAddEdit(item)"><i class="fa fa-plus-square"
                                    aria-hidden="true"></i> Add Q.</label>
                            <i class="fa fa-trash ml-2" style="color: #aaa4a4;" aria-hidden="true"
                                (click)="removeSurvey(item?.id)"></i>
                        </div>
                    </div>
                    <section class="row mt-4">

                        <div class="col-4">
                            <label class="m-0"><i class="fa fa-rss-square" aria-hidden="true"></i> Type</label>
                            <div><b>{{item?.type}}</b></div>
                        </div>

                        <div class="col-4">
                            <label class="m-0"><i class="fa fa-clock" aria-hidden="true"></i> Start Date</label>
                            <div><b>{{item?.startDate | date:'dd-MM-yyyy' }}</b></div>
                        </div>

                        <div class="col-4">
                            <label class="m-0"><i class="fa fa-clock" aria-hidden="true"></i> End Date</label>
                            <div><b>{{item?.endDate | date:'dd-MM-yyyy'}}</b></div>
                        </div>
                    </section>

                    <section class="row mt-4">
                        <div class="col">
                            <label class="m-0" (click)="getResponse(Response,item?.id)"><i class="fa fa-users"
                                    aria-hidden="true"></i> Responses</label>
                        </div>
                    </section>
                </section>
            </ng-container>
        </div>
    </section>
    <!-- survey -->

    <!-- questions -->
    <section [ngStyle]="{'display': selMenu=='questions' ? 'block' :'none' }" class="mt-3">
        <div class="d-flex justify-content-end" (click)="openQuestionAddEdit()">
            <button class="btn btn-primary">
                <i class="fa-solid fa-plus"></i> Add Questions
            </button>
        </div>
        <div class="row mt-3">
            <ng-container>
                <table class="table table-hover white_box shadow">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Survey</th>
                            <th scope="col">Question Type</th>
                            <th scope="col">Question</th>
                            <th scope="col">Option</th>
                            <th scope="col">Tag</th>
                            <th scope="col">Assign Interests To Question</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of allQuestionList; let i = index;">
                            <th scope="row">{{i + 1}}</th>
                            <td class="row"><span class="sub-cate">{{'Survey '+ item?.memberSurvey.title }}</span></td>
                            <td>{{item?.question_type}}</td>
                            <td>{{item?.question_text}}</td>
                            <td>
                                <div class="row">
                                    <ng-container *ngFor="let i of item?.options">
                                        <span class="sub-cate m-1">{{i}}</span>
                                    </ng-container>
                                </div>

                            </td>
                            <td>
                                <div class="row">
                                    <ng-container *ngFor="let i of item?.answerMappings">
                                        <span class="sub-cate m-1"> {{i.interest.interest_name}} <i class="fa fa-trash"
                                                aria-hidden="true" (click)="removeTagMapping(i.id)"></i></span>
                                    </ng-container>
                                </div>
                            </td>
                            <td width="500">
                                @if(item?.interestMapping){
                                {{item?.interestMapping}}
                                }@else{
                                <button class="btn btn-dark" (click)="assignTag(AssignTag,item)"><i class="fa fa-pencil"
                                        aria-hidden="true"></i> Assign</button>
                                }

                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>
        </div>
    </section>
    <!-- questions -->

    <!-- Tag -->
    <section [ngStyle]="{'display': selMenu=='interests' ? 'block' :'none' }" class="mt-3">
        <div class="d-flex justify-content-end" (click)="openTagAddEdit()">
            <button class="btn btn-primary">
                <i class="fa-solid fa-plus"></i> Add Tag
            </button>
        </div>
        <div class="row mt-3">
            <ng-container>
                <table class="table table-hover white_box shadow">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Tag Name</th>
                            <th scope="col">Tag Type</th>
                            <th scope="col">Tag Description</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of allInterestsList; let i = index;">
                            <th scope="row">{{i + 1}}</th>
                            <td><span class="sub-cate">{{ item?.interest_name }}</span></td>
                            <td>{{ item?.type.toUpperCase() }}</td>
                            <td>{{ item?.description }}</td>
                            <td class="text-right">
                                <section class="d-flex justify-content-center" style="gap: 5px;">
                                    <button class="btn btn-dark" (click)="openTagAddEdit(item)"><i class="fa fa-pencil"
                                            aria-hidden="true"></i> Edit</button>
                                    <button class="btn btn-danger" (click)="removeTag(item?.id)"><i class="fa fa-trash"
                                            aria-hidden="true"></i> Delete</button>
                                </section>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </ng-container>
        </div>
    </section>
    <!-- Tag -->

</section>



<ng-template #AddSurvey let-modal>
    <div id="add_prod_detail" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
        <div class=""></div>
        <div class="modal-body">
            <form [formGroup]="form">

                <div class="row">

                    <div class="form-group col-12">
                        <label>Survey Title </label>
                        <input type="text" rows="3" placeholder="Enter Title" class="form-control"
                            formControlName="title">
                    </div>

                    <div class="form-group col-12">
                        <label>Survey Type </label>
                        <input type="text" rows="3" placeholder="Enter Type" class="form-control"
                            formControlName="type">
                    </div>
                    <div class="form-group col-12">
                        <label for="exampleInputEmail1">Survey Description </label>
                        <textarea type="text" formControlName="description" class="form-control" row="6"
                            id="exampleInputEmail1" aria-describedby="emailHelp"
                            placeholder="Enter Event Name"></textarea>
                    </div>
                    <div class="form-group col-12">
                        <label>Survey Start Date </label>

                        <input type="text" formControlName="startDate" class="form-control" [owlDateTimeTrigger]="dt3"
                            [owlDateTime]="dt3" [ngModelOptions]="{standalone: true}" id="exampleInputEmail1"
                            aria-describedby="emailHelp" placeholder="Enter Event Date">
                        <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time>

                    </div>
                    <div class="form-group col-12">
                        <label>Survey End Date </label>
                        <input type="text" formControlName="endDate" class="form-control" [owlDateTimeTrigger]="dt2"
                            [owlDateTime]="dt2" [ngModelOptions]="{standalone: true}" id="exampleInputEmail1"
                            aria-describedby="emailHelp" placeholder="Enter Event Date">
                        <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
                    </div>


                </div>
                <div class="mt-3 text-right">
                    <button class="btn btn-secondary mr-2" (click)="modal.close()">
                        <i class="fa-solid fa-times"></i> Cancel
                    </button>
                    <button class="btn btn-primary" (click)="saveSurvey()">
                        <i class="fa-solid fa-save"></i> Save
                    </button>
                </div>

            </form>
        </div>
    </div>
</ng-template>

<ng-template #Tag let-modal>
    <div id="add_prod_detail" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
        <div class=""></div>
        <div class="modal-body">
            <form [formGroup]="tagForm">

                <div class="row">

                    <div class="form-group col-12">
                        <label>Tag Name </label>
                        <input type="text" rows="3" placeholder="Enter Title" class="form-control"
                            formControlName="interest_name">
                    </div>
                    <div class="form-group col-12">
                        <label>Tag Description </label>
                        <input type="text" rows="3" placeholder="Enter Title" class="form-control"
                            formControlName="description">
                    </div>

                </div>
                <div class="mt-3 text-right">
                    <button class="btn btn-secondary mr-2" (click)="modal.close()">
                        <i class="fa-solid fa-times"></i> Cancel
                    </button>
                    <button class="btn btn-primary" (click)="saveTag()">
                        <i class="fa-solid fa-save"></i> Save
                    </button>
                </div>

            </form>
        </div>
    </div>
</ng-template>

<ng-template #AssignTag let-modal>
    <div id="add_prod_detail" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
        <div class=""></div>
        <div class="modal-body">
            <div class="row">

                <div class="form-group col-12">
                    <label>Tag Type </label>
                    <select class="form-control" formControlName="type" (change)="handleTagType($event)">
                        <option *ngFor="let item of ['Common', 'Category', 'Age', 'Gender', 'Character Traits']"
                            value="{{item}}">{{item}}</option>
                    </select>
                </div>
                <div class="form-group col-12">
                    <label>Tag </label>
                    <select2 [data]="allInterestsListDropdown" [value]="selectedTag" [overlay]="false" [width]="'100%'"
                        hideSelectedItems="true" (update)="handleSelectedTag($event)">
                    </select2>
                </div>

                <div class="form-group col-12">
                    <label>Answer Keyword </label>
                    <input type="text" rows="3" [(ngModel)]="answerKeyword" placeholder="Enter Title"
                        class="form-control">
                </div>


            </div>
            <div class="mt-3 text-right">
                <button class="btn btn-secondary mr-2" (click)="modal.close()">
                    <i class="fa-solid fa-times"></i> Cancel
                </button>
                <button class="btn btn-primary" (click)="saveAssignTag()">
                    <i class="fa-solid fa-save"></i> Save
                </button>
            </div>

        </div>
    </div>
</ng-template>


<ng-template #AddQuestion let-modal>
    <div id="add_prod_detail" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
        <div class=""></div>
        <div class="modal-body">
            <section class="row">

                <div class="col-5 overflow-auto" style="max-height: 80vh; border-right: solid #e6e6e6ab;">
                    <h2>Question List</h2>
                    <ng-container *ngFor="let i of allSurveyQuestionList">
                        <div class="question mt-3">
                            <div class="operation"> <label class="m-0" (click)="editQuestion(i)"><i class="fa fa-pencil"
                                        aria-hidden="true"></i> Edit</label>
                                <i class="fa fa-trash ml-2" style="color: #aaa4a4;" aria-hidden="true"
                                    (click)="removeQuestion(i?.id)"></i>
                            </div>
                            <label class="text_desc"><b>Question [{{i?.position}}]</b> : {{i?.question_text}}</label>
                        </div>
                    </ng-container>
                </div>
                <div class="col-7">
                    <h2>Add/Edit</h2>
                    <form [formGroup]="questionForm">

                        <div class="row">

                            <div class="form-group col-12">
                                <label>Question Order </label>
                                <input placeholder="Enter Question Order" type="number" class="form-control"
                                    formControlName="position">
                            </div>

                            <div class="form-group col-12 mt-2">
                                <label>Question Type </label>
                                <select placeholder="Select Type" class="form-control" formControlName="question_type">
                                    <option selected disabled value=""> Select Question Type</option>
                                    <option value="single">Question With Single Responses</option>
                                    <option value="multiple">Question With Multiple Responses</option>
                                    <option value="text">Question With Text Responses</option>
                                </select>
                            </div>



                            <div class="form-group col-12">
                                <label>Question text </label>
                                <textarea rows="6" placeholder="Enter Question text" class="form-control"
                                    formControlName="question_text"></textarea>
                            </div>

                            <div class="form-group col-12 mt-2"
                                *ngIf="questionForm.get('question_type').value == 'multiple' || questionForm.get('question_type').value == 'single'">
                                <label>Question options </label>
                                <div class="d-flex">
                                    <input type="text" rows="3" placeholder="Enter options" class="form-control"
                                        formControlName="options">
                                    <button class="btn btn-secondary ml-2" style="width: 6rem;"
                                        (click)="addQuestionOption()">
                                        <i class="fa fa-plus-square"></i> Add
                                    </button>
                                </div>

                                <ul style="padding: 1rem 2rem;">
                                    <li style="list-style: lower-alpha; background-color: #ffd2238c; padding: 3px 10px; border-radius: 8px;margin: 5px 0px;"
                                        *ngFor="let j of questionOptions">{{j}}</li>
                                </ul>
                            </div>


                        </div>


                    </form>

                    <div class="mt-3 text-right">
                        <button class="btn btn-secondary mr-2" (click)="modal.close()">
                            <i class="fa-solid fa-times"></i> Close
                        </button>
                        <button class="btn btn-primary mr-2" (click)="newQuestion()">
                            <i class="fa-solid"></i> New
                        </button>
                        <button class="btn btn-primary" (click)="saveQuestion()">
                            <i class="fa-solid fa-save"></i> Save
                        </button>
                    </div>
                </div>

            </section>

        </div>
    </div>
</ng-template>

<ng-template #Response let-modal>
    <div id="add_prod_detail" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
        <div class=""></div>
        <div class="modal-body">
            <h2>Survey Response</h2>
            <canvas baseChart [data]="surveyData" [options]="chartOptions" chartType="bar">
            </canvas>
        </div>
    </div>
</ng-template>